import React from 'react';

export default ({ toggleModal, columns, setReportingColumns }) => {
    let originalCols = [];

    const ChangeColumn = column => {
        let checkedCount = 0;

        for (let i = 0; i < columns.length; i++) {
            if (
                document.getElementsByClassName('reporting-modal__checkbox')[i]
                    .checked
            ) {
                checkedCount++;
            }
        }

        if (checkedCount >= 18) {
            for (let i = 0; i < columns.length; i++) {
                if (
                    !document.getElementsByClassName(
                        'reporting-modal__checkbox'
                    )[i].checked
                ) {
                    document.getElementsByClassName(
                        'reporting-modal__checkbox'
                    )[i].disabled = true;
                }
            }
        } else {
            for (let i = 0; i < columns.length; i++) {
                document.getElementsByClassName('reporting-modal__checkbox')[
                    i
                ].disabled = false;
            }
        }

        let index = originalCols.indexOf(column);
        if (index >= 0) {
            originalCols.splice(index);
        } else {
            originalCols.push(column);
        }
    };

    const SetColumns = () => {
        toggleModal();
        if (originalCols.length) setReporting(originalCols, columns);
    };

    const setReporting = (property, reportingColumns) => {
        return reportingColumns.filter(row => {
            for (let i = 0; i < property.length; i++) {
                if (row.property === property[i].property) {
                    row.visible = !row.visible;
                }
            }
            return row;
        });
    };

    return (
        <div>
            <ul className="form__item--checkbox reporting-modal">
                {columns.map((column, i) => {
                    return (
                        <li key={i} className="reporting-modal--item">
                            <label className="form__label">
                                <input
                                    type="checkbox"
                                    className="form__checkbox reporting-modal__checkbox"
                                    value="{column.property}"
                                    defaultChecked={column.visible}
                                    onClick={() => ChangeColumn(column)}
                                />
                                <span className="form__title">
                                    {column.header.label}
                                </span>
                            </label>
                        </li>
                    );
                })}
            </ul>
            <button
                className="btn align-right modal-dialog__close"
                onClick={() => SetColumns()}
            >
                Apply
            </button>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/reporting/column-controls.js